namespace pixi_heaven {
	export enum CLAMP_OPTIONS {
		NEVER = 0,
		AUTO = 1,
		ALWAYS = 2
	}

	export let settings = {
		MESH_CLAMP: CLAMP_OPTIONS.AUTO,
		BLEND_ADD_UNITY: false,
	}
}
